<section class="main_head">
    <div class="container-fluid">
      <div class="row top_main animated delay-2s zoomIn ">
        <div class="top_left animated pulse delay-3s">
          <img src="../../assets/img/home_left.png" class="img_left" width="auto" >
        </div>
        <div class="top_right topright_margin animated delay-5s backInDown">
          <h6 class="text-left text-white ml-5 this_is mb-1">This is me ,</h6>
          <h2><b><span>Nurul Hassan</span></b></h2>
          <div id="typed-strings" class="typed_text">
            <span>" <strong>Student</strong> "</span>
            <span>" <strong>Developer</strong> "</span>
          </div>
          <span id="typed" class="typed_text"></span>
          <br><br>
          <div class="topmain_btn my-3">
            <h6><a routerLink="/my_work"  class="portfolio">Work</a></h6>
            <h6><a routerLink="/contact_me" class="contact_me">Contact me</a></h6>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="container-fluid main_intro">
    <div class="container">
      <article>
       <div class="align-center pt-5 text-center">Hi.</div>
       <div class="text-center animated fadeIn delay-1s">This is Nurul Hassan<br>
        I'm 20 Years Old And Pursuing B.Tech in Information Technology From Jecrc Jaipur.<br>I am in  <a href="https://www.linkedin.com/in/nurulhassan/" class="link">Linkedin</a> <a href="https://github.com/nurulhassan" class="link"><span>,</span> GitHub</a> And For More Details You Can See <a href="about.html" class="link">About Me</a>.
        <h6 class="mt-5"><a href="../../assets/docs/offcamp.pdf" target="_blank" download="Nurul_Resume" class="resume">Check Out My Resume</a></h6>
      </div>
    </article>
  </div>
  <section id="what-i-do" class="topic_head">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <article>
            <h1 class="text-center mb-10 ">What I can do.</h1>
            <div id="design" class="row py-3">
              <div class="col-md-4 col-md-offset-1">
                <div class="home-design-info">
                  <figure>
                    <img src="../../assets/img/avatar.png">
                  </figure>
                  <div class="bubble right">
                    <div class="bubbling-design-icons-vert"></div>
                  </div>      
                </div>
              </div> 
              <div class="col-md-6">
                <div class="deets">                
                  <h3>Design what you want.</h3>
                  <p>I like to keep it simple. My goals are to focus on typography, content and conveying the message that you want to send.</p>
                </div>
              </div>
            </div>
            <div id="develop" class="row">
              <div class="col-md-4 col-md-push-7">
                <div class="home-dev-info">
                  <figure>
                    <img src="../../assets/img/avatar.png">
                  </figure>
                  <div class="bubble left">
                    <div class="bubbling-dev-icons-vert">
                    </div>
                  </div>      
                </div>
              </div>
              <div class="col-md-6 col-md-pull-3">
                <div class="deets">
                  <h3>Develop what you need.</h3>
                  <p>I'm a developer, so I know how to create your website to run across devices using the latest technologies available.</p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</section>
<section class="services-area topic_head animated fadeIn topic_head">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="menu-content  col-lg-7">
        <div class="title text-center">
          <h1 class="mb-10">Things I Do..</h1>
          <p>At about this time of year, some months after New Year’s resolutions have been made and kept, or made and neglected.</p>
        </div>
      </div>
    </div>            
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <span class="lnr lnr-pie-chart"></span>
          <a href="#"><h4>Web Design</h4></a>
          <p>
            “It is not because things are difficult that we do not dare; it is because we do not dare that they are difficult.”
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <span class="lnr lnr-laptop-phone"></span>
          <a href="#"><h4>Web Development</h4></a>
          <p>
            If you are an entrepreneur, you know that your success cannot depend on the opinions of others. Like the wind, opinions.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <span class="lnr lnr-layers"></span>
          <a href="#"><h4>Create robust & scalable
          infrastructure</h4></a>
          <p>
           Develop robust infra while keeping
           the budget low.
         </p>
       </div>  
     </div>
     <div class="col-lg-4 col-md-6">
      <div class="single-services">
        <span class="lnr lnr-picture"></span>
        <a href="#"><h4>Clipping Path</h4></a>
        <p>
          Hypnosis quit smoking methods maintain caused quite a stir in the medical world over the last two decades. There is a lot of argument.
        </p>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="single-services">
        <span class="lnr lnr-tablet"></span>
        <a href="#"><h4>Apps Interface</h4></a>
        <p>
          Do you sometimes have the feeling that you’re running into the same obstacles over and over again? Many of my conflicts.
        </p>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="single-services">
        <span class="lnr lnr-laptop-phone"></span>
        <a href="#"><h4>Develop elegant and sleek
        interfaces at 60 FPS</h4></a>
        <p>
          Sleek and fast software always thrills me. I like to make them fast and interactive.
        </p>
      </div>        
    </div>                            
  </div>
</div>  
</section>
<section class="container topic_head">
  <h1 class="text-center">Tools</h1>
  <div class="row mt-5">
    <div class="col-md-4">
      <div class="tool_card ">
        <div class="tool_image" style="background-image: url('../../assets/img/atom.png');">
        </div>
        <div class="card_title">Atom</div>
        <div class="card_description">Atom is a text editor that's modern, approachable, yet hackable to the core.</div>

      </div>
    </div>
    <div class="col-md-4">
      <div class="tool_card" >
        <div class="tool_image" style="background-image: url('../../assets/img/vs.png');">
        </div>
        <div class="card_title">Visual Studio</div>
        <div class="card_description">Microsoft Visual Studio is an integrated development environment (IDE) from Microsoft. My go to ide while i'm using windows.</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="tool_card " >
        <div class="tool_image" style="background-image: url('../../assets/img/sublime.png');">
        </div>
        <div class="card_title">Sublime Text</div>
        <div class="card_description">It natively supports many programming languages and markup languages, and functions can be added by users with plugins, typically community-built and maintained under free-software licenses.</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="tool_card " >
        <div class="tool_image" style="background-image: url('../../assets/img/google.png');">
        </div>
        <div class="card_title">Google Suite</div>
        <div class="card_description">Drive is my best source of backup and maintenance. I’m a heavy user of all their services.</div>

      </div>
    </div>
    <div class="col-md-4">
      <div class="tool_card " >
        <div class="tool_image" style="background-image: url('../../assets/img/github.png');">
          <img src="../../assets/img/github.png" height="100%" width="auto">
        </div>
        <div class="card_title">Github</div>
        <div class="card_description">Github is platform that allows code storage and collabration in your team by using GIT.</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="tool_card " >
        <div class="tool_image">
          <img src="../../assets/img/slack.png" height="100%" width="auto">
        </div>
        <div class="card_title">Slack</div>
        <div class="card_description">A great and friendly tool for communication within the team. It has great set of integrations.</div>
      </div>
    </div>
  </div>  
</section>
